import React from 'react';
import {Box} from "@mui/material";
import {styled} from "@mui/material/styles";
import {BeatLoader} from "react-spinners";
import {useRecoilValue} from "recoil";
import {loadingState} from "@services/stores/storeState";

const Background = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(0, 0, 0, 0.3)',
    zIndex: 9999
})

const BackgroundLoading = () => {

    const isLoading = useRecoilValue(loadingState);

    return (
        <>
            { isLoading ?
                <Background>
                    <BeatLoader color={'#41a1ea'} loading={true} margin={10} size={10} />
                    {/*<HashLoader color={'#41a1ea'} loading={true} size={100} />*/}
                    {/*<FadeLoader color={"#41a1ea"} loading={true} height={25} width={5} margin={20} radius={20} />*/}
                </Background>
                : <></>
            }
        </>
    )
};

export default BackgroundLoading;
